import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const QatarFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_15824'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_15824)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M20.0006 0H5.71484L7.14342 0.933333L5.71484 1.86667L7.14342 2.8L5.71484 3.73333L7.14342 4.66667L5.71484 5.6L7.14342 6.53333L5.71484 7.46667L7.14342 8.4L5.71484 9.33333L7.14342 10.2667L5.71484 11.2L7.14342 12.1333L5.71484 13.0667L7.14342 14H20.0006V0Z'
					fill='#A6264C'
				/>
			</g>
		</svg>
	);
};

export default QatarFlagIcon;
